import React from "react";
import MapControl from "./MapControl";

const MapTilerLogo = () => (
  <MapControl position="bottomleft">
    <a href="https://www.maptiler.com" target="_blank">
      <img
        style={{ width: "67px", height: "20" }}
        src="https://api.maptiler.com/resources/logo.svg"
        alt="MapTiler logo"
      />
    </a>
  </MapControl>
);

export default MapTilerLogo;
